export default "__VITE_ASSET__e0b74640__"